import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IAdminMissionState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const adminMissionModule: Module<IAdminMissionState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default adminMissionModule
